module.exports = "/*\n * CLICK AnalyticsEvent\n */\nfunction AnalyticsClickEvent(name, options) {\n\n\tthis.build(name, options);\n\tthis.trigger = 'click';\n}\n// > Inheritance\n\nAnalyticsClickEvent.prototype = AnalyticsTriggerEvent.prototype; "


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/analytics/legacy/framework/events/AnalyticsClickEvent.legacy.js
// module id = 800
// module chunks = 31